import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import SyllabusPage from './pages/SyllabusPage'
import LearnPage from './pages/LearnPage'
import RealWorldPage from './pages/RealWorldPage'
import TutorPage from './pages/TutorPage'
import GraphPage from './pages/GraphPage'
import OntologyPage from './pages/OntologyPage'
import RulesPage from './pages/RulesPage'
import MCPConsolePage from './pages/MCPConsolePage'
import MCPPage from './pages/MCPPage'
import ChatPage from './pages/ChatPage'
import UnitDetailPage from './pages/UnitDetailPage'
import ProblemPage from './pages/ProblemPage'
import TestPage from './pages/TestPage'
import AuthPage from './pages/AuthPage'
import OnboardingPage from './pages/OnboardingPage'
import AdminRoute from './components/AdminRoute'
import { useAuthStore } from './store/authStore'
import VideoSubmitPage from './pages/VideoSubmitPage'
import RealLifeCalcPage from './pages/RealLifeCalcPage'
import GrowthPage from './pages/GrowthPage'
import ChallengePage from './pages/ChallengePage'
import VideoReviewPage from './pages/VideoReviewPage'
import CreatorDashboardPage from './pages/CreatorDashboardPage'

export default function App() {
  const { initAuth } = useAuthStore()

  // 앱 시작 시 세션 복원
  useEffect(() => { initAuth() }, [])

  return (
    <Routes>
      {/* 인증 페이지 — Layout 없이 전체 화면 */}
      <Route path="/auth" element={<AuthPage />} />
      {/* 수포자 전용 온보딩 — Layout 없이 전체 화면 */}
      <Route path="/onboarding" element={<OnboardingPage />} />

      {/* 나머지 모든 페이지 — Layout 포함 */}
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/syllabus" element={<SyllabusPage />} />
            <Route path="/unit/:unitId" element={<UnitDetailPage />} />
            <Route path="/learn" element={<LearnPage />} />
            <Route path="/realworld" element={<RealWorldPage />} />
            <Route path="/tutor" element={<TutorPage />} />
            <Route path="/graph" element={<GraphPage />} />
            <Route path="/problems" element={<ProblemPage />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/ontology" element={<AdminRoute><OntologyPage /></AdminRoute>} />
            <Route path="/rules" element={<AdminRoute><RulesPage /></AdminRoute>} />
            <Route path="/mcp" element={<AdminRoute><MCPConsolePage /></AdminRoute>} />
            <Route path="/mcp-info" element={<AdminRoute><MCPPage /></AdminRoute>} />
            <Route path="/chat" element={<ChatPage />} />
            {/* 크리에이터 & 영상 관련 */}
            <Route path="/video-submit" element={<VideoSubmitPage />} />
            <Route path="/real-calc" element={<RealLifeCalcPage />} />
            <Route path="/growth" element={<GrowthPage />} />
            <Route path="/challenge" element={<ChallengePage />} />
            <Route path="/creator-dashboard" element={<CreatorDashboardPage />} />
            <Route path="/video-review" element={<AdminRoute><VideoReviewPage /></AdminRoute>} />
          </Routes>
        </Layout>
      } />
    </Routes>
  )
}
